import { IconTrash } from "app/components/Icon/Icon";
import { BetSlipType } from "app/types/betSlipType";
import { BetBuilderStates } from "app/utils/const";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import BetRunnerName from "../../../BetRunnerName/BetRunnerName";
import MarketName from "../../../MarketName";
import PeriodName from "../../../PeriodName";
import "./BetBuilderItem.scss";

type props = {
  item: BetSlipType;
  index: number;
  numberOfItems: number;
  selections: any[];
  overallStatus: any[];
};

const BetBuilderItem: React.FC<props> = ({
  item,
  index,
  numberOfItems,
  selections,
  overallStatus,
}) => {
  const dispatch = useDispatch();

  const deleteItem = (ev: React.MouseEvent): void => {
    dispatch.betBuilderModel.removeBetBuilderItem(item);
  };

  // Used for drawing the vertical line
  const isLastItem = index === numberOfItems - 1;
  const isFirstItem = index === 0;
  const lineCssClass = isLastItem
    ? "bet-builder-item__vertical-line__last"
    : isFirstItem
    ? "bet-builder-item__vertical-line__first"
    : "";
  const selection =
    selections && Array.isArray(selections) && selections[index];

  return (
    <>
      <div className={`bet-builder-item`}>
        <span className="bet-builder-item__dot"></span>
        {numberOfItems > 1 && (
          <div
            className={`bet-builder-item__vertical-line ${lineCssClass}`}
          ></div>
        )}
        <div className="bet-builder-item__row">
          <div className="bet-builder-item__content">
            <span className="bet-builder-item__runner-name">
              <BetRunnerName betSlip={item} />
            </span>
            <span className="bet-builder-item__market-and-period">
              <MarketName betSlip={item} />
              <PeriodName betSlip={item} />
            </span>
            {/* Render a new div if the selection is unavailable */}
            {selection?.outcome?.status === BetBuilderStates.UNAVAILABLE && (
              <div className="bet-builder-item__removal-note">
                <div className="note-text">
                  {/* Logic implimented here so that the removal note is displayed when an event
                  is closed/suspended off site or is made  redundant */}
                  {overallStatus?.status === BetBuilderStates.REDUNDANT_LEG && (
                    <FormattedMessage tagName="span" id="bets-removal-note" />
                  )}

                  {overallStatus?.status === BetBuilderStates.UNAVAILABLE && (
                    <span></span>
                  )}
                </div>
              </div>
            )}
          </div>
          <button
            onClick={deleteItem}
            className="bet-builder-item__delete-button"
            // disabled={isItemClosed} // Disable delete button if the item is closed
          >
            <IconTrash />
          </button>
        </div>
      </div>
    </>
  );
};

export default BetBuilderItem;
